import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { useAuth } from "../helper/useAuth";
import dayjs from "dayjs";
import { IApiResponse } from "../../features/Apps/interface";

// Default pagination values
const PAGINATION = {
  page: 1,
  per_page: 999999999,
};

interface IAppListParams {
  startDate: Date;
  endDate: Date;
  page?: number;
  per_page?: number;
}

export const useAppListData = ({
  startDate,
  endDate,
  page,
  per_page,
}: IAppListParams) => {
  const { selectedIntegration } = useAuth();

  // Get today's date at midnight for cache key
  const today = dayjs().startOf("day").format("YYYY-MM-DD");

  // Format dates for query key to ensure it updates when dates change
  const fromDate = dayjs(startDate).format("YYYY-MM-DD");
  const toDate = dayjs(endDate).format("YYYY-MM-DD");

  return useQuery({
    queryKey: [
      "appList",
      selectedIntegration?.value,
      fromDate,
      toDate,
      today,
      page,
      per_page,
    ],
    queryFn: async () => {
      const response = await httpService.get<IApiResponse>(
        API_CONFIG.path.getApps,
        {
          page: page || PAGINATION.page,
          per_page: per_page || PAGINATION.per_page,
          from: fromDate,
          to: toDate,
          status: "all",
          tracking_id: selectedIntegration?.value as string,
        }
      );
      return response;
    },
    // Only fetch if we have a selected integration
    enabled: !!selectedIntegration?.value,
    // Cache for 24 hours
    staleTime: 24 * 60 * 60 * 1000,
    gcTime: 24 * 60 * 60 * 1000,
  });
};
